var exports = {
  "DR": "Box_0__Of4oB0",
  "wy": "Box_1__njPIlr",
  "N2": "Text_0__HFNcpL",
  "pv": "Box_2__gS00tP",
  "w9": "Box_3__JXVejD",
  "pQ": "Box_4__RPybEY",
  "UE": "Text_1__R-FNg7",
  "Qb": "RemoveFilterButton_0__lHg5w_",
  "ws": "Box_5__psUINx",
  "D6": "Box_6__jYNG2U",
  "KI": "Box_7__VQJXwG",
  "pm": "Box_8__ouhtwG",
};

module.exports = exports;
